export const ONLINE_WINDOW_MS = 120_000;
export const PRESENCE_TICK_MS = 30_000;
export const PRESENCE_HEARTBEAT_MS = 45_000;

export function parsePresenceTime(value) {
    if (value == null || value === '') {
        return null;
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value < 1e12 ? value * 1000 : value;
    }
    const ms = Date.parse(value);
    return Number.isFinite(ms) ? ms : null;
}

export function isOnlineAt(lastActiveAtMs, nowMs = Date.now()) {
    return lastActiveAtMs != null && nowMs - lastActiveAtMs < ONLINE_WINDOW_MS;
}
